/* unplugin-vue-components disabled */import __unplugin_components_1 from '/var/repos/bic-vue/src/components/common/ModalComponent.vue';
import __unplugin_components_0 from '/var/repos/bic-vue/src/components/login/SignInForm.vue';
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
  class: "p-12 flex flex-col"
};
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "self-center mt-4"
}, [/*#__PURE__*/_createElementVNode("form", {
  method: "dialog"
}, [/*#__PURE__*/_createElementVNode("button", {
  class: "btn btn-sm btn-neutral"
}, "Close")])], -1);
export default {
  __name: 'LoginModal',
  setup(__props) {
    const $eventBus = inject('bus');
    const selectedForm = ref('login');
    onMounted(() => {
      $eventBus.$on('open-login-modal', whichModal => {
        selectedForm.value = whichModal;
        login_modal.showModal();
      });
    });
    onBeforeUnmount(() => {
      $eventBus.$off('open-login-modal');
    });
    return (_ctx, _cache) => {
      const _component_SignInForm = __unplugin_components_0;
      const _component_ModalComponent = __unplugin_components_1;
      return _openBlock(), _createBlock(_component_ModalComponent, {
        name: "login_modal"
      }, {
        image: _withCtx(() => []),
        content: _withCtx(() => [_createElementVNode("div", _hoisted_1, [(_openBlock(), _createBlock(_component_SignInForm, {
          key: _unref(selectedForm),
          whichForm: _unref(selectedForm)
        }, null, 8, ["whichForm"])), _hoisted_2])]),
        _: 1
      });
    };
  }
};